import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import WebsiteLayout from "./layouts/WebsiteLayout";
import AdminLayout from "./admin/components/AdminLayout";

import ProdList from './Pages/ProdList';
import ProductDetails from "./Pages/ProductDetails";
import Cart from './Pages/Cart';
import Wishlist from './Pages/Wishlist';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MainPage from './Pages/MainPage';
import Checkout from './Pages/checkout';
import Login from './Pages/Login';
import Register from './Pages/Register';
import PrivateRoute from "./Components/ProtectedRoute";
import OrderSuccess from './Pages/OrderSuccess';
import Invoice from "./Pages/Invoice";
import MyOrders from "./Pages/MyOrders";
import OrderDetails from './Pages/OrderDetails';


import Dashboard from "./admin/pages/Dashboard";
import Categories from "./admin/pages/Categories";
import SubCategoryList from './admin/pages/SubCategoryList';
import ProductPage from './admin/pages/ProductPage';
import ProductImageManager from "./admin/pages/ProductImageManager";
import AdminRoute from "./Components/AdminRoute";
import AdminOrders from './admin/pages/AdminOrders';
import AdminSlider from './admin/pages/AdminSlider';
import ShopDetails from './admin/pages/ShopDetails';
import InvoiceSettings from './admin/pages/InvoiceSettings';
import PaymentSettings from './admin/pages/PaymentSettings';
import ShippingSettings from './admin/pages/ShippingSettings';



function App() {
  return (
    <>
      <ToastContainer position="top-right" autoClose={2000} />

      
      <Routes>

        {/* 🌐 WEBSITE ROUTES */}
        <Route path="/" element={<WebsiteLayout />}>
          <Route index element={<MainPage />} />
          <Route path="productlist" element={<ProdList />} />
          <Route path="product/:id" element={<ProductDetails />} />
          <Route path="cart" element={<Cart />} />
          <Route path="wishlist" element={<Wishlist />} />
          <Route path="login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/checkout"
            element={
             <PrivateRoute>
               <Checkout />
             </PrivateRoute>
            }
         />
         <Route path="/order-success/:orderId" element={<OrderSuccess />} />
         <Route path="/invoice/:orderId" element={<Invoice />} />
         <Route path="/my-orders" element={<MyOrders />} />
         <Route path="/order-details/:orderId" element={<OrderDetails />} />
        </Route>

        {/* 🛠 ADMIN ROUTES */}
        <Route
          path="/admin"
           element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="/admin/categories" element={<Categories />} />
          <Route path="/admin/subcategories" element={<SubCategoryList />} />
          <Route path="/admin/products" element={<ProductPage />} />
          <Route path="/admin/product-images/:productId" element={<ProductImageManager />}/>
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="/admin/sliders" element={<AdminSlider />} />

          <Route path="/admin/shopdetails" element={<ShopDetails />} />
          <Route path="/admin/invoicesetting" element={<InvoiceSettings />} />
          <Route path="/admin/paymentsetting" element={<PaymentSettings />} />
          <Route path="/admin/shippingsetting" element={<ShippingSettings />} />

        </Route>

      </Routes>

      
    </>
  );
}

export default App;
